<template>
  <div class="tab-pane fade" id="cross-region" role="tabpanel" aria-labelledby="cross-region-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-lg-5 col-md-7">
          <label class="form-label">風景區</label><br>
          <select id="selectScenicArea" class="selectpicker" v-model.number="selectScenicAreas" multiple >
            <option :value="selectAll" >全部</option>
            <option v-for="(list, index) in carFlowScenicArea" :key="index" :value="list">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-6 col-lg-3">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime"  @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 col-lg-3">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime"  @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk()"
            :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="exportMothCSV()"
            :disabled="isWaitCCTVList">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">跨景區比較</h1>
      <p>備註 1 ：統計欄位的預估人流為各日預估人流（含負值）總和且四捨五入至整數位。</p>
      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="crossRegion" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">風景區</th>
                    <th scope="col">機車</th>
                    <th scope="col">小型車</th>
                    <th scope="col">大型車</th>
                    <th scope="col">小巴</th>
                    <th scope="col">卡車</th>
                    <th scope="col">預估人流</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in estimatePeopleList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td style="white-space: pre-line;">{{ item.time }}</td>  <!-- style讓 \n可以換行-->
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.motorbike }}</td>
                    <td>{{ item.car }}</td>
                    <td>{{ item.bus }}</td>
                    <td>{{ item.smallbus }}</td>
                    <td>{{ item.truck }}</td>
                    <td>{{ removeNegativeAndDecimal(item.estimatePeopleCount) }}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2 ">
          <div id="cross-region-chart">
            <apexchart type="line" height="200" :options="chartSetting" :series="chartData"></apexchart>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import { mapState, mapGetters } from 'vuex'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { postVehicleInTimeIntervalPerHour } from '../../api/eastCoastDataApi/ElkQuery/VehicleElk'
import exportCSV from '../../utils/exportCSV'
import ApexchartObject from '../../utils/apexchartObject/searchCar'



export default {
  components: { apexchart: VueApexCharts, },
  data() {
    return {
      Const: CONST,
      selectAll: CONST.MULTI_SELECT_ALL,
      toggleAllStatus:false,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      estimatePeopleList: [],
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectScenicAreas: [],
      selectDeviceId: "-1",
      carTypeList: CONST.ELK_CAR_TYPE_ENUM,
      selectCarType: '',
      selectItem: null,
      ratioData: null,
      isWaitCCTVList: false,
      chartData: [],
      chartSetting: {...ApexchartObject.crossRegionOption},
      maxSelectTime: moment().startOf('m').toISOString(),

    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),
    ...mapGetters({ ScenicAreaCCTVList: 'getScenicAreaVehicleVideoCamera' }),
    ...mapState("passengerEstimateSetting", { estimateDataList: "allEstimateData" }),

     carFlowScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },
  },
  watch: {
    async selectScenicAreaId() {
      this.isWaitCCTVList = true
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      this.selectDeviceId = "-1"
      this.isWaitCCTVList = false
    },

    carFlowScenicArea(){
      this.$nextTick(() => {
      // 確保DOM更新後再次刷新selectpicker

      $('#selectScenicArea').selectpicker({
      noneSelectedText: '請選擇'
        });
      })
    },
    selectScenicAreas: {
     handler(newValue, oldValue){
       if(newValue[0] === CONST.MULTI_SELECT_ALL&& oldValue [0] !== CONST.MULTI_SELECT_ALL){
        //表示若已有選擇其他景區，再選擇全部的情況
         $('#selectScenicArea').selectpicker('selectAll');
       }
       
       if(newValue[0] !== CONST.MULTI_SELECT_ALL&& oldValue [0] === CONST.MULTI_SELECT_ALL){
         //表示取消全部選擇的情況
         
         $('#selectScenicArea').selectpicker('deselectAll');
         this.selectScenicAreas = [];
        }
        if(oldValue[0] === CONST.MULTI_SELECT_ALL && newValue.length < oldValue.length ){
          // console.log("從選擇全部中移除部分景區")
          //表示選擇全部，但是未全選
          
          //表示從全選狀態離開，產生非全選的狀態，移除陣列this.selectScenicAreas的[0](selectAll)
          this.selectScenicAreas.shift();
        }}
    }

  },
  methods: {
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    removeNegativeAndDecimal(value) {
      //若 value < 0 則回傳 0，若value小數則僅無條件捨去小數點後三位
      return value < 0 ? 0 : Math.floor(value*100)/100
    },

    async queryElk() {
      this.isWaitCCTVList = true
    
      const dataList = await this.searchELK();

      this.setChartData(dataList)
      this.estimatePeopleList = dataList
      this.updateTable()
      this.isWaitCCTVList = false
    },

    async exportMothCSV() {
      this.isWaitCCTVList = true
      const estimatePeopleList = await this.searchELK();

      const csvContent = [['時間', '風景區', '機車', '小型車', '大型車', '小巴', '卡車', '預估人流']]
      estimatePeopleList.forEach(item => {
        const row = []
        row.push(item.time.replace(/\n/g, ''))
        row.push(item.areaName)
        row.push(item.motorbike)
        row.push(item.car)
        row.push(item.bus)
        row.push(item.smallbus)
        row.push(item.truck)
        row.push(this.removeNegativeAndDecimal(item.estimatePeopleCount))

        csvContent.push(row)
      })

      const fileName = `即時_車流推估人流${moment(this.startTime).format('YYYY/MM/DD HH:mm')}.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitCCTVList = false
    },

    sumData(dataList) {
      const total = {
        time: '統計',
        areaName: '',
        motorbike: 0,
        car: 0,
        bus: 0,
        smallbus: 0,
        truck: 0,
        estimatePeopleCount: 0,
      }

      dataList.forEach(item => {
        total.motorbike = total.motorbike + item.motorbike
        total.car = total.car + item.car
        total.bus = total.bus + item.bus
        total.smallbus = total.smallbus + item.smallbus
        total.truck = total.truck + item.truck
        total.estimatePeopleCount = total.estimatePeopleCount + item.estimatePeopleCount
      })
      total.estimatePeopleCount = Math.round(total.estimatePeopleCount);

      dataList.push(total)

      return dataList
    },

    async searchELK(scenicArea) {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "day"
      }

      if(this.selectScenicAreas.length === 0 || this.selectScenicAreas[0] === CONST.MULTI_SELECT_ALL) {
        condition.areas = this.carFlowScenicArea.map(sc => sc.id) // 預設全選 
      } else {
        condition.areas = this.selectScenicAreas.map(sc => sc.id)
      }

      const result = await postVehicleInTimeIntervalPerHour(condition)
      if(!result.success){
        return []
      }

      const carTypeEnumList = this.$store.getters['passengerEstimateSetting/getInternalEstimateWeight']
      const holidayMap = this.$store.getters['holidaySetting/getHolidayMap']
      const total = {
        time: '統計',
        areaName: '',
        motorbike: 0,
        car: 0,
        bus: 0,
        smallbus: 0,
        truck: 0,
        estimatePeopleCount: 0
      }

      const dataList = result.data.map(e => {
        const data ={}
        data.areaName = e.areaName
        data.time = `${moment(e.dateTime).format('YYYY/MM/DD')}`
        data.motorbike = e.data.motorbike
        data.car = e.data.car
        data.bus = e.data.bus
        data.smallbus = e.data.smallbus
        data.truck = e.data.truck
        data.estimatePeopleCount =  e.totalPeopleFlow


        const date = moment(e.dateTime).startOf('day').format().split('+')[0]
        const weight = holidayMap.get(date) ? 'holidayWeight' : 'weight'
        
        total.motorbike = total.motorbike + data.motorbike
        total.car = total.car + data.car
        total.bus = total.bus + data.bus
        total.smallbus = total.smallbus + data.smallbus
        total.truck = total.truck + data.truck
        total.estimatePeopleCount = total.estimatePeopleCount + data.estimatePeopleCount 
        
        return data
      })
      total.estimatePeopleCount = Math.round(total.estimatePeopleCount);

      dataList.push(total)
      return dataList
    },

    setChartData(dataList) {
      const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列
      const sumList = Object.values(list.reduce((acc, obj) => {
        //將相同遊客中心的人數相加
        if (acc[obj.areaName]) {
          acc[obj.areaName].estimatePeopleCount += obj.estimatePeopleCount;
        } else {
          acc[obj.areaName] = { ...obj };
        }
        return acc;
      }, {}));


      this.chartData = []
      const peopleCount = sumList.map((d, i) => {
        return d.estimatePeopleCount
      })

      // this.chartData.push({name: '在園人數', data: peopleStayCount})
      this.chartData.push({ name: '推估人數', data: peopleCount })
      // this.chartData.push({name: '離場人數', data: peopleOutCount})   


      let chartSetting = { ...this.chartSetting }
      const xaxisCategories = sumList.map((d, i) => {
        // return `${moment(d.time).format('MM/DD')}`
        return d.areaName //景區名稱
      })
      chartSetting = {...chartSetting, ...{xaxis:{categories: xaxisCategories}}} //https://github.com/apexcharts/vue-apexcharts/issues/74#issuecomment-472717678
      chartSetting.chart.toolbar.export={
              csv: {
                filename: `跨景區_車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              svg: {
                filename: `跨景區_車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              png: {
                filename: `跨景區_車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              }
            }

      this.chartSetting = { ...chartSetting } // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    initTable: function () {
      this.table = $("#crossRegion").DataTable({
        aoColumns: [
          ...new Array($("#crossRegion th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: '/json/dataTableZHTW.json'
        },
        "pageLength": 10
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable();
    setTimeout(() => {
        $('#selectScenicArea').selectpicker({
        noneSelectedText: '請選擇'
         });
      }, 500);

  },
}
</script>

<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */</style>
